import { Box, Container, Typography } from "@mui/material";
import MenuService from "../../components/Menu/menuService";
import { useEffect } from "react";

const TermsAndConditions = () => {
  const boldWeight = 700;
  const titleStyle = { fontWeight: boldWeight, fontSize: "1.5rem !important" };

  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("terms-and-conditions");
  }, []);

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          backgroundColor: "white",
          marginTop: "30px",
          marginBottom: "100px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            rowGap: 2,
            alignItems: "flex-start",
          }}
        >
          <Box>
            <Typography variant="h1">
              Collecticos Terms and Conditions of Use
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              These Terms and Conditions ("Terms") outline the guidelines for
              using the Collecticos platform, a service provided by Collecticos
              B.V., located at John M. Keynesplein 12, B21066 EP Amsterdam.
              Please read these Terms carefully to understand your rights and
              obligations when using our platform. By using our service, you
              agree to these Terms.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 1. Definitions
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              In these Terms, the following definitions apply:
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.1{" "}
              <Box component="span" fontWeight={boldWeight}>
                Platform
              </Box>
              : Collecticos’ digital platform, accessible through the website
              and mobile applications, where users can create and manage their
              football shirt collections.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.2{" "}
              <Box component="span" fontWeight={boldWeight}>
                User
              </Box>
              : Any individual or entity that registers an account on
              Collecticos or uses the platform, with or without registering.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.3{" "}
              <Box component="span" fontWeight={boldWeight}>
                Profile
              </Box>
              : The personalized section of the platform, created and managed by
              a user upon registration.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.4{" "}
              <Box component="span" fontWeight={boldWeight}>
                Service
              </Box>
              : The platform functionality provided by Collecticos, including
              free and VIP accounts, where users can upload football shirts,
              access market value estimations, peer-to-peer authentications, and
              other related services.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.5{" "}
              <Box component="span" fontWeight={boldWeight}>
                VIP Account
              </Box>
              : A paid subscription service, costing €5 per month, offering
              unlimited shirt uploads, AI-driven market value assessments,
              peer-to-peer authentication features, and more.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.6{" "}
              <Box component="span" fontWeight={boldWeight}>
                Database
              </Box>
              : The repository of information, including football shirt data,
              user profiles, and collections maintained by Collecticos.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.7{" "}
              <Box component="span" fontWeight={boldWeight}>
                Football Shirts
              </Box>
              : Items that users upload and track on the platform, including
              images, descriptions, and market data.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              1.8{" "}
              <Box component="span" fontWeight={boldWeight}>
                Authentication
              </Box>
              : The peer-to-peer process where users can verify the authenticity
              of each other’s football shirts.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 2. Applicability and Changes to the Terms
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              2.1 These Terms apply to every use of the platform. By using the
              platform, you accept these Terms.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              2.2 Collecticos may amend these Terms at any time. Users will be
              notified of changes via the website or by email 15 days before new
              Terms take effect. Continued use of the platform indicates
              acceptance of the revised Terms.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 3. The Service
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              3.1 The Collecticos platform offers free and paid features to
              football shirt collectors. Users can:
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              Upload shirts to their digital collection.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              Access AI-driven market value estimations.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              Authenticate other users' shirts and have theirs authenticated.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              Browse a database of sold shirts, including pricing.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              3.2 VIP users enjoy additional benefits such as unlimited uploads
              and advanced privacy controls.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              3.3 Collecticos reserves the right to modify, suspend, or
              discontinue any part of the platform at any time without notice.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 4. User Responsibilities
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              4.1 Users are responsible for providing accurate information
              during registration and maintaining the confidentiality of their
              login credentials.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              4.2 Users are accountable for the content they upload, including
              images, descriptions, and authentication data.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              4.3 Users agree not to upload or share unlawful content or
              infringe on the rights of third parties.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 5. VIP Subscription and Payment
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              5.1 The VIP service costs €5 per month, offering users premium
              features. Payment must be made in advance.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              5.2 Collecticos reserves the right to modify subscription fees,
              with prior notice given to users.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 6. Intellectual Property Rights
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              6.1 Users retain the rights to the content they upload but grant
              Collecticos a non-exclusive, worldwide license to display and
              promote this content on the platform.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              6.2 Collecticos may remove any content it deems inappropriate or
              in violation of these Terms.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 7. Availability and Interruption of the Service
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              7.1 Collecticos does not guarantee that the Service will be
              accessible at all times without interruptions or breakdowns.
              Interruptions may occur due to issues such as internet or
              telephone connection problems, viruses, or defects. Collecticos is
              not liable to you or obligated to pay any compensation for damages
              caused by the temporary or permanent unavailability or
              interruption of the Service.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              7.2 Collecticos reserves the right, without prior notice, to make
              procedural or technical changes and improvements to the Website
              and/or Service.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              7.3 Collecticos reserves the right, without becoming liable for
              compensation, to temporarily shut down or limit the Service, for
              instance, for necessary maintenance. Collecticos will inform you
              in advance when possible.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 8. Intellectual Property Rights
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              8.1 The Intellectual Property Rights related to the Website, the
              Service, the Database, and the Information—including but not
              limited to texts, images, designs, photographs, software, and
              audiovisual materials—are owned by Collecticos or its licensors,
              unless it concerns User Material. Intellectual Property Rights for
              User Material remain with the Users or their licensors.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              8.2 Under these Terms of Use, Collecticos grants you a limited,
              personal, revocable, non-exclusive, non-sublicensable,
              non-transferable right to use the Service and view the Information
              as made available via the Service.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              8.3 Copying, distributing, or using the Service, User Material
              that is not your own, or any other information for commercial
              purposes without explicit written consent from Collecticos or the
              relevant rights holder is prohibited.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              8.4 It is prohibited to remove, obscure, or alter notices related
              to Intellectual Property Rights.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              8.5 Nothing in these Terms transfers Intellectual Property Rights
              to you. Your use of the Service is limited to what is permitted
              under these Terms. Activities that could infringe on the rights of
              Collecticos, Users, or third parties—such as registering domain
              names or using similar trademarks—are prohibited.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 9. Privacy and Access to Data
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              9.1 When creating your profile and using the Service, you provide
              personal data to Collecticos. This data will be stored and
              processed according to Collecticos’ Privacy Policy and applicable
              laws.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              9.2 Collecticos has access to personal data such as usernames,
              passwords, name and address details, email addresses, purchase and
              sales data, and User Material as outlined in the Privacy Policy.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              9.3 Users have access to personal data, including their own
              profile, User Material (to the extent it has been made public or
              shared with specific users), and buyer/seller details if a
              transaction occurs.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 10. Database Rights
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              10.1 The Database is protected under the Dutch Database Act.
              Collecticos holds exclusive rights to allow extraction or reuse of
              the entire or substantial parts of the Database. Repeated or
              systematic extraction of non-substantial parts that conflict with
              normal Database use is also prohibited unless permitted under
              these Terms.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 11. Reporting Allegedly Unlawful Material
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              11.1 To handle third-party rights infringements, Collecticos has
              established a procedure for reporting allegedly unlawful User
              Material on the Website. This can be done via the Report of
              Allegedly Unlawful Material.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              11.2 Collecticos is not liable for damages related to the unlawful
              use of the Website or Service but will remove manifestly unlawful
              User Material upon receiving a valid report.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              11.3 Collecticos reserves the right to reject requests for
              removing or blocking User Material if the report lacks sufficient
              evidence or if it conflicts with the balance of interests. A court
              ruling may be required to demonstrate that the material is
              manifestly unlawful.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              11.4 Collecticos is not a party to disputes between users or
              between users and third parties over User Material.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              11.5 By submitting a report, you indemnify Collecticos and its
              affiliates from any claims related to the blocking or removal of
              User Material.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 12. Liability and Indemnity
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.1 Collecticos acts as an intermediary between users and is not
              liable for User Material or third-party information provided via
              the Website or Service.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.2 Collecticos accepts no liability for property damage,
              financial loss, or other damages due to service disruptions,
              including use or inability to use the Service, except as permitted
              under applicable mandatory law.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.3 Collecticos is not responsible for damages arising from
              agreements between users. For example, if you enter into a deal
              that is unfavorable, Collecticos is not liable for any loss you
              may incur.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.4 The only recourse if you suffer damages is to stop using the
              Service and delete your profile.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.5 If Collecticos is found liable, liability is limited to
              direct damages, which include material damage to property,
              reasonable costs to prevent or limit damages, and costs to
              determine the cause of the damage.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.6 Collecticos’ maximum liability is limited to €5,000 (five
              thousand euros).
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.7 You indemnify Collecticos from any claims by third parties
              arising from your use of the Website, Service, or violation of
              these Terms.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.8 You indemnify Collecticos for costs incurred due to requests,
              orders, or judgments related to your User Material.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              12.9 This limitation of liability does not exclude Collecticos
              from liability for willful misconduct or gross negligence.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 13. Termination
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              13.1 You may stop using the Service and delete your profile at any
              time.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              13.2 Collecticos may restrict, suspend, or terminate your account
              without notice if you violate these Terms. Collecticos is not
              liable for any compensation due to such actions.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 14. Miscellaneous
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              14.1 Dutch law exclusively governs these Terms, the Website, and
              the Service, as well as any disputes arising from them.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              14.2 If you are not acting in a professional capacity, disputes
              will be submitted to the competent court of your jurisdiction or
              the district court where Collecticos is located, unless otherwise
              required by national or international law.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              14.3 If you are acting in a professional capacity, all disputes
              will be submitted to the competent court in the district of
              Amsterdam.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              14.4 These Terms replace any previous agreements between you and
              Collecticos. Any verbal statements or arrangements are legally
              binding only if confirmed in writing.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              14.5 Collecticos may transfer its rights and obligations under
              these Terms to third parties and will notify you in such cases. If
              you do not accept this, you may discontinue using the Service and
              delete your profile.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              14.6 If any part of these Terms is found invalid, you and
              Collecticos remain bound by the remaining sections.
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1" sx={titleStyle}>
              Article 15. Contact
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              For any questions regarding the Service, the Website, or these
              Terms, you can contact Collecticos via the contact form at
              https://www.collecticos.com/en/help/contact or by emailing
              info@collecticos.com.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default TermsAndConditions;
